import axios from 'axios';

// Use relative path for API to work with any domain (custom domains, preview URLs, etc.)
// The /api prefix is handled by the reverse proxy/ingress
const API = '/api';

/**
 * Get axios config with authentication.
 *
 * Auth is delivered exclusively via the httpOnly `session_token` cookie set
 * by `/auth/password-login`. We intentionally DO NOT read or write the token
 * to localStorage — that would expose it to any same-origin script (XSS).
 * If your deployment sits behind a domain where cookies don't flow, fix the
 * cookie flags server-side rather than falling back to localStorage here.
 */
export const getAuthConfig = () => ({
  withCredentials: true,
  headers: {},
});

/**
 * Make authenticated GET request
 */
export const authGet = async (endpoint) => {
  return axios.get(`${API}${endpoint}`, getAuthConfig());
};

/**
 * Make authenticated POST request
 */
export const authPost = async (endpoint, data = {}) => {
  return axios.post(`${API}${endpoint}`, data, getAuthConfig());
};

/**
 * Make authenticated PUT request
 */
export const authPut = async (endpoint, data = {}) => {
  return axios.put(`${API}${endpoint}`, data, getAuthConfig());
};

/**
 * Make authenticated PATCH request
 */
export const authPatch = async (endpoint, data = {}) => {
  return axios.patch(`${API}${endpoint}`, data, getAuthConfig());
};

/**
 * Make authenticated DELETE request
 */
export const authDelete = async (endpoint) => {
  return axios.delete(`${API}${endpoint}`, getAuthConfig());
};

/**
 * Check if user is authenticated
 */
export const checkAuth = async () => {
  const response = await authGet('/auth/me');
  return response.data;
};

/**
 * Logout — clears the server-side session row and the httpOnly cookie.
 */
export const logout = async () => {
  try {
    await authPost('/auth/logout');
  } catch (error) {
    console.error('Logout error:', error);
  }
};

export { API };
